import { createGraphqlFetcher } from '@apis/createFetcher';

const apis = {
    verifyTrackCode: {
        name: 'otherServiceApi',
        query: `query otherServiceApi($where: ServiceApiInput!){
                otherServiceApi(where:$where)
            }`
    },
    getBillList: {
        name: 'getBillListBySid',
        query: `query getBillListBySid($sid: String!){
            getBillListBySid(sid:$sid)
        }`
    },
    addStripeCard: {
        name: 'addStripeCard',
        query: `mutation addStripeCard($where: AddCardInput!){
            addStripeCard(args:$where)
        }`
    },
    changeStripeDefaultCard: {
        name: 'changeStripeDefaultCard',
        query: `mutation changeStripeDefaultCard($where: StripeUpdateSourceCard!){
            changeStripeDefaultCard(args:$where)
        }`
    },
    deleteStripeCard: {
        name: 'deleteStripeCard',
        query: `mutation deleteStripeCard($where: StripeUpdateSourceCard!){
            deleteStripeCard(args:$where)
        }`
    },
    createCancelRecurringPayMsg: {
        name: 'createCancelRecurringPayMsg',
        query: `mutation createCancelRecurringPayMsg($input: CancelRecurringPayMsgCreateInput!){
            createCancelRecurringPayMsg(input:$input)
        }`
    },

    cancelRecurringPay: {
        name: 'cancelRecurringPay',
        query: `mutation cancelRecurringPay($args: CancelRecurringPayInput!){
            cancelRecurringPay(args:$args)
        }`
    },
    getPayInfo: {
        name: 'getPayInfo',
        query: `query getPayInfo($sid: String!){
            getPayInfo(sid:$sid)
        }`
    },
    pteSiteStatus: {
        name: 'pteSiteStatus',
        query: `query pteSiteStatus($sid: String!){
            pteSiteStatus(sid:$sid){
                sid
                crossDomainEnabled
            }
        }`
    },
    updatePteStatus: {
        name: 'updatePteSiteStatus',
        query: `mutation updatePteSiteStatus($data: PteSiteStatusInput!, $where:PteSiteStatusWhereUniqueInput!) {
            updatePteSiteStatus(data:$data, where:$where)
        }`
    },
    activeProductInProfile: {
        name: 'activeProfileFromNewPtengine',
        query: `mutation activeProfileFromNewPtengine($where: NewPtengineProfileWhereUniqueInput!) {
            activeProfileFromNewPtengine(where:$where) {
                ownerEmail
                sid
                siteid
                type
                name
                domain
                timeZone
                createTime
                updateTime
                isActived
                activeTime
                profileSource
                status
                engageCount
                engageRunningCount
                usergroupCount
                goalCount
                currentUserRole
                ptxUserRole
                ptiUserRole
                pteEnabled
                ptxEnabled
                ptengineCrossDomainSetting
                sevenPV
                sevenActiveUsers
                consumedProfile
            }
        }`
    },
    resetTrial: {
        name: 'resetTrialPackageEndTime',
        query: `query resetTrialPackageEndTime($profileId: String!) {
            resetTrialPackageEndTime(profileId: $profileId)
        }`
    },
    updateProfile: {
        name: 'activeProfileFlag',
        query: `mutation activeProfileFlag($where: ProfileWhereUniqueInput!){
            activeProfileFlag(where: $where)
        }`
    },
    applyTrial: {
        name: 'openAutomaticallyNpFreeTrialPackage',
        query: `mutation openAutomaticallyNpFreeTrialPackage($data: NpFreeTrialPackageInput!) {
            openAutomaticallyNpFreeTrialPackage(data: $data)
        }`
    },
    activeCollaborativeUser: {
        name: 'activeCollaborativeUser',
        query: `mutation activeCollaborativeUser($data: AccountProfileInput!){
            activeCollaborativeUser(data:$data)
        }`
    },
    getAllCollaborativeUser: {
        name: 'getAllCollaborativeUser',
        query: `query getAllCollaborativeUser($profileId: String!){
            getAllCollaborativeUser(profileId: $profileId) {
                aid
                name
                email
                role
                createtime
                status
            }
        }`
    },
    removeCollaborativeUser: {
        name: 'removeCollaborativeUser',
        query: `mutation removeCollaborativeUser($profileId: String!, $aid: String!){
            removeCollaborativeUser(profileId:$profileId, aid:$aid)
        }`
    },
    updateUserRole: {
        name: 'updateUserRole',
        query: `mutation updateUserRole($profileId: String!, $aid:String!, $role:String!) {
            updateUserRole(profileId:$profileId, aid:$aid, role:$role)
        }`
    },
    addCollaborativeUser: {
        name: 'addCollaborativeUser',
        query: `mutation addCollaborativeUser($data: AddCollaborativeUserInput!){
            addCollaborativeUser(data:$data)
        }`
    },
    getPtiHeatmapList: {
        name: 'getPtiHeatMapUrlList',
        query: `query getPtiHeatMapUrlList($input: HeatMapUrlListInput!) {
            getPtiHeatMapUrlList(input: $input){
                url
                pv
                pid
            }
        }`
    },
    checkActiveProfile: {
        name: 'checkActiveProfile',
        query: `query checkActiveProfile($where: ProfileWhereUniqueInput!) {
            checkActiveProfile(where: $where)
        }`
    }
};
export default createGraphqlFetcher(apis);
